import React, { useEffect } from "react";
import DOMPurify from "dompurify";
import { useImageSliderStore } from "../../../../stores/use-image-slider-store";
import {
  StyledEditableTextarea,
  StyledTextareaCalculator,
} from "../../../../components/inline-edit/styled";

function EditableText({
  data,
  isEditable,
  field,
  customCalculatorStyles = {},
}) {
  const updateImage = useImageSliderStore((state) => state.updateImage);

  const textareaRef = React.useRef();
  const textareaHelperRef = React.useRef();

  const value = data[field];

  useEffect(() => {
    if (!data.id || !isEditable) return;

    const resizeObserver = new ResizeObserver((entries) => {
      const entry = entries[0];
      const helperHeight = entry.contentRect.height;
      if (textareaRef?.current) {
        textareaRef.current.style.height = `${helperHeight}px`;
      }
    });
    const element = document.getElementById(
      `${data.id}-${field}-image-content-text-area-helper`
    );
    if (element) {
      resizeObserver.observe(element);
    }
  }, [data.id, isEditable, value]);

  return (
    <>
      {isEditable ? (
        <>
          <StyledEditableTextarea
            ref={textareaRef}
            value={value}
            onInput={(e) =>
              updateImage({
                id: data.id,
                key: field,
                value: e.target.value,
              })
            }
          />
          <StyledTextareaCalculator
            id={`${data.id}-${field}-image-content-text-area-helper`}
            ref={textareaHelperRef}
            width="100%"
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(value) }}
            style={{ ...customCalculatorStyles }}
          />
        </>
      ) : (
        value
      )}
    </>
  );
}

export default EditableText;
